import React, { useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchBlob } from "../../../utils/http";
import { FaSearch } from "react-icons/fa";

import EessAutocomplete from "../../../components/autocomplete/EessAutocomplete";
import EstadoSelect from "../../../components/select/EstadoSelect";

const FORMATO_OPCIONES = [
  { id: "PDF", label: "PDF" },
  { id: "EXCEL", label: "EXCEL" },
];

export default function ListadoDePinesEess() {
  const [descargando, setDescargando] = useState(false);

  const [eess, setEess] = useState(null);
  const [estado, setEstado] = useState(null);
  const [numeroResponsable, setNumeroResponsable] = useState("");
  const [tipoPin, setTipoPin] = useState("");
  const [formato, setFormato] = useState("PDF");

  const handleConsultar = async () => {
    try {
      setDescargando(true);

      const params = new URLSearchParams();

      if (eess?.id) params.append("eessId", eess.id);
      if (estado?.id) params.append("estadoId", estado.id);
      if (numeroResponsable)
        params.append("numeroResponsable", numeroResponsable);
      if (tipoPin) params.append("tipo", tipoPin);

      params.append("formato", formato);

      const url = apiRoutes.pines.reportPinesEess(params);

      const { blob, filename } = await appFetchBlob(
        url,
        { method: "GET" },
        { showLoading: true }
      );

      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      const extension = formato === "PDF" ? "pdf" : "xlsx";

      a.href = downloadUrl;
      a.download =
        filename || `Listado_Pines_Eess.${extension}`;

      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);

    } catch (error) {
      console.error("Error en descarga:", error);
    } finally {
      setDescargando(false);
    }
  };

  return (
    <div className="w-full p-4 md:p-6">
      <div className="bg-white border rounded-md shadow-sm">

        {/* HEADER */}
        <div className="px-4 md:px-6 py-4 border-b flex flex-col md:flex-row md:items-center md:justify-between bg-gray-50 gap-2">
          <h2 className="text-lg md:text-xl font-semibold text-gray-800">
            Introduzca los datos del reporte de Pines de EESS
          </h2>
        </div>

        {/* BODY */}
        <div className="p-4 md:p-6">
          <div className="bg-gray-100 p-4 md:p-8 rounded-md space-y-4 md:space-y-5 max-w-4xl mx-auto">

            {/* EE.SS */}
            <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
              <label className="md:w-48 shrink-0 font-bold text-gray-700">
                EE.SS.:
              </label>
              <div className="w-full max-w-[500px]">
                <EessAutocomplete
                  value={eess}
                  onChange={setEess}
                />
              </div>
            </div>

            {/* ESTADO */}
            <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
              <label className="md:w-48 shrink-0 font-bold text-gray-700">
                Estado:
              </label>
              <div className="w-full max-w-[500px]">
                <EstadoSelect
                  value={estado}
                  onChange={setEstado}
                  tipoId={5}
                />
              </div>
            </div>

            {/* NRO RESPONSABLE */}
            <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
              <label className="md:w-48 shrink-0 font-bold text-gray-700">
                Nro Responsable:
              </label>
              <input
                type="number"
                value={numeroResponsable}
                onChange={(e) => setNumeroResponsable(e.target.value)}
                className="input w-full max-w-[500px]"
              />
            </div>

            {/* TIPO PIN */}
            <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
              <label className="md:w-48 shrink-0 font-bold text-gray-700">
                Tipo Pin:
              </label>
              <select
                value={tipoPin}
                onChange={(e) => setTipoPin(e.target.value)}
                className="input w-full max-w-[500px]"
              >
                <option value="">-- Seleccione --</option>
                <option value="CLIENTE">CLIENTE</option>
                <option value="PLAYERO">PLAYERO</option>
                <option value="MAESTRA">MAESTRA</option>
              </select>
            </div>

            {/* FORMATO */}
            <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
              <label className="md:w-48 shrink-0 font-bold text-gray-700">
                Formato:
              </label>
              <select
                value={formato}
                onChange={(e) => setFormato(e.target.value)}
                className="input w-full max-w-[500px]"
              >
                {FORMATO_OPCIONES.map((op) => (
                  <option key={op.id} value={op.id}>
                    {op.label}
                  </option>
                ))}
              </select>
            </div>

          </div>
        </div>

        {/* FOOTER */}
                <div className="px-4 md:px-6 py-4 border-t bg-gray-50 flex justify-start">
          <button
            onClick={handleConsultar}
            disabled={descargando}
            className={`flex items-center gap-2 text-white font-semibold py-2 px-6 rounded shadow transition-colors ${
              descargando
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-green-800 hover:bg-green-900"
            }`}
          >
            {descargando ? (
              <svg
                className="animate-spin h-4 w-4 text-white"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8H4z"
                ></path>
              </svg>
            ) : (
              <FaSearch className="text-sm" />
            )}
            <span>{descargando ? "Descargando..." : "Consultar"}</span>
          </button>
        </div>

      </div>
    </div>
  );
}
